import React from "react";

const Privacy = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
      <p className="mb-4">Last Updated: {new Date().toLocaleDateString()}</p>
      
      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">Introduction</h2>
        <p className="mb-2">
          This Privacy Policy describes how we collect, use, and handle your information when you use our service. 
          We take your privacy seriously and are committed to protecting your personal information.
        </p>
      </section>
      
      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">Information We Collect</h2>
        <p className="mb-2">
          When you use our service, we may collect the following information:
        </p>
        <ul className="list-disc pl-6 mb-2">
          <li>Information you provide to us directly, such as your name and email address when you sign up</li>
          <li>Information from Google when you use Google Sign-In, such as your Google profile information</li>
          <li>Usage data and information about how you interact with our service</li>
          <li>Device information including your browser type, IP address, and operating system</li>
        </ul>
      </section>
      
      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">How We Use Your Information</h2>
        <p className="mb-2">We use the information we collect to:</p>
        <ul className="list-disc pl-6 mb-2">
          <li>Provide, maintain, and improve our service</li>
          <li>Process and complete transactions</li>
          <li>Send you technical notices, updates, and administrative messages</li>
          <li>Respond to your comments, questions, and requests</li>
          <li>Personalize your experience on our service</li>
          <li>Monitor and analyze trends, usage, and activities in connection with our service</li>
        </ul>
      </section>
      
      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">Information Sharing and Disclosure</h2>
        <p className="mb-2">
          We do not share your personal information with third parties except as described in this Privacy Policy:
        </p>
        <ul className="list-disc pl-6 mb-2">
          <li>With your consent</li>
          <li>To comply with laws or respond to lawful requests</li>
          <li>To protect the rights, property, or safety of our users or the public</li>
          <li>In connection with a merger, sale of company assets, financing, or acquisition</li>
        </ul>
      </section>
      
      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">Data Security</h2>
        <p className="mb-2">
          We implement appropriate security measures to protect the security of your personal information and prevent 
          unauthorized access, alteration, disclosure, or destruction of your information.
        </p>
      </section>
      
      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">Your Rights</h2>
        <p className="mb-2">
          You have the right to access, correct, or delete your personal information. You can request access 
          to your personal information or its deletion by contacting us.
        </p>
      </section>
      
      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">Changes to This Privacy Policy</h2>
        <p className="mb-2">
          We may update this Privacy Policy from time to time. We will notify you of any changes by posting 
          the new Privacy Policy on this page and updating the "Last Updated" date.
        </p>
      </section>
      
      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">Contact Us</h2>
        <p className="mb-2">
          If you have any questions about this Privacy Policy, please contact us.
        </p>
      </section>
    </div>
  );
};

export default Privacy; 